let lastIndex = 0;

const ImageIndex = () => lastIndex++;

export default ImageIndex;



// WEBPACK FOOTER //
// ./src/components/image_index.js